import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYoutubeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_15778_132866)",
		children: [/* @__PURE__ */ _jsx("path", { d: "M11.0039 14.7483L14.9073 12.5001L11.0039 10.252V14.7483Z" }), /* @__PURE__ */ _jsx("path", { d: "M22.7691 0.5H2.2309C1.2749 0.5 0.5 1.2749 0.5 2.2309V22.7691C0.5 23.7251 1.2749 24.5 2.2309 24.5H22.7691C23.7251 24.5 24.5 23.7251 24.5 22.7691V2.2309C24.5 1.2749 23.7251 0.5 22.7691 0.5V0.5ZM19.9982 12.5123C19.9982 12.5123 19.9982 14.9459 19.6895 16.1194C19.5164 16.7618 19.0099 17.2682 18.3676 17.4411C17.1941 17.75 12.5 17.75 12.5 17.75C12.5 17.75 7.81818 17.75 6.63239 17.4288C5.99005 17.256 5.48358 16.7493 5.31055 16.107C5.00165 14.9459 5.00165 12.5 5.00165 12.5C5.00165 12.5 5.00165 10.0665 5.31055 8.89301C5.4834 8.25067 6.00232 7.73175 6.63239 7.5589C7.80591 7.25 12.5 7.25 12.5 7.25C12.5 7.25 17.1941 7.25 18.3676 7.57117C19.0099 7.74402 19.5164 8.25067 19.6895 8.89301C20.0106 10.0665 19.9982 12.5123 19.9982 12.5123Z" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_15778_132866",
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 24,
			height: 24,
			rx: 12
		})
	}) })]
});
export { SvgYoutubeIcon as ReactComponent };
